// As avaliações dos clientes (comida e entrega, 1–5, comentário) de um restaurante ou de um estafeta.
import React, { useEffect, useState } from 'react';
import {
  Alert, Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Rating,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography,
} from '@mui/material';
import api from '../../services/api';

interface Avaliacao {
  orderId: number;
  ratingFood: number | null;
  ratingDelivery: number | null;
  comment: string | null;
  createdAt: string;
  restaurant: string;
  driver?: string | null;
}

interface Props {
  open: boolean;
  onClose: () => void;
  titulo: string;
  filtro: { restaurantId?: number; driverId?: string };
}

const AvaliacoesDialog: React.FC<Props> = ({ open, onClose, titulo, filtro }) => {
  const [lista, setLista] = useState<Avaliacao[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const { restaurantId, driverId } = filtro;

  useEffect(() => {
    if (!open) return;
    setLoading(true);
    setError(null);
    api.get('/food/admin/reviews', { params: { restaurantId, driverId } })
      .then((res) => setLista(res.data.data || []))
      .catch((e) => setError(e?.response?.data?.error || 'Não foi possível carregar as avaliações'))
      .finally(() => setLoading(false));
  }, [open, restaurantId, driverId]);

  const porEstafeta = !!driverId;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Avaliações · {titulo}</DialogTitle>
      <DialogContent>
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        {loading ? (
          <Box sx={{ py: 4, textAlign: 'center' }}><CircularProgress size={28} /></Box>
        ) : lista.length === 0 ? (
          <Typography color="text.secondary" sx={{ py: 3, textAlign: 'center' }}>Ainda sem avaliações</Typography>
        ) : (
          <TableContainer>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Data</TableCell>
                  <TableCell>Pedido</TableCell>
                  <TableCell>{porEstafeta ? 'Restaurante' : 'Estafeta'}</TableCell>
                  <TableCell>Comida</TableCell>
                  <TableCell>Entrega</TableCell>
                  <TableCell>Comentário</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {lista.map((a) => (
                  <TableRow key={a.orderId} hover>
                    <TableCell sx={{ whiteSpace: 'nowrap' }}>
                      {new Date(a.createdAt).toLocaleDateString('pt-CV', { timeZone: 'Atlantic/Cape_Verde' })}
                    </TableCell>
                    <TableCell>#{a.orderId}</TableCell>
                    <TableCell>{porEstafeta ? a.restaurant : (a.driver || '—')}</TableCell>
                    <TableCell>{a.ratingFood ? <Rating value={a.ratingFood} readOnly size="small" /> : '—'}</TableCell>
                    <TableCell>{a.ratingDelivery ? <Rating value={a.ratingDelivery} readOnly size="small" /> : '—'}</TableCell>
                    <TableCell>{a.comment || <Typography variant="body2" color="text.disabled">Sem comentário</Typography>}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Fechar</Button>
      </DialogActions>
    </Dialog>
  );
};

export default AvaliacoesDialog;
